import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import asyncLoading from 'react-async-loader';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

import projectConfig from '../../../config';

class StreetView extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
    value: PropTypes.shape({}),
    googleMaps: PropTypes.shape({})
  };

  constructor(...props) {
    super(...props);
    this.streetView = null;
    this.internalUpdate = false;
  }

  componentDidMount() {
    this.initializeOrUpdate(this.props);
  }

  componentDidUpdate() {
    this.initializeOrUpdate(this.props);
  }

  componentWillUnmount() {
    const { googleMaps } = this.props;

    if (this.streetView) {
      googleMaps.event.clearInstanceListeners(this.streetView);
    }
  }

  _getPanoramaOptions(props) {
    const { value } = props;
    const properties = get(value, 'properties', {});
    const coordinates = get(value, 'coordinates', [30.5222797, 50.4510839]);
    return {
      position: { lat: coordinates[1], lng: coordinates[0] },
      pov: { heading: properties.heading || 100, pitch: properties.pitch || 0 },
      zoom: properties.zoom || 1
    };
  }

  initializeOrUpdate(props) {
    this.internalUpdate = true;
    if (props.googleMaps && this.streetView == null) {
      this.initialize(props);
    }
    if (props.googleMaps && this.streetView != null) {
      this.update(props);
    }
    // Workaround for streetview behavior - it always calls position_changed and pov_changed
    // when setPosition, setPov and other methods are calls
    setTimeout(() => this.internalUpdate = false, 500);
  }

  initialize = (props) => {
    const div = ReactDOM.findDOMNode(this); // eslint-disable-line
    const canvas = div.firstChild;
    const opts = this._getPanoramaOptions(props);
    if (props.onClose) {
      opts.enableCloseButton = true;
    }
    this.streetView = new props.googleMaps.StreetViewPanorama(
      canvas,
      opts
    );

    this.streetView.addListener('position_changed', this.handlePositionChanged);
    this.streetView.addListener('pov_changed', this.handlePovChanged);
    if (props.onClose) {
      this.streetView.addListener('closeclick', props.onClose);
    }
  };

  update(props) {
    const opts = this._getPanoramaOptions(props);
    this.streetView.setPosition(opts.position);
    this.streetView.setPov(opts.pov);
    this.streetView.setZoom(opts.zoom);
  }

  handlePositionChanged = () => {
    const coord = this.streetView.getPosition();
    this.handleChange({ coordinates: [coord.lng(), coord.lat()] });
  };

  handlePovChanged = () => {
    const pov = this.streetView.getPov();
    const zoom = this.streetView.getZoom();
    this.handleChange({
      heading: pov.heading,
      pitch: pov.pitch,
      zoom
    });
  };

  handleChange(val) {
    if (this.internalUpdate) return;
    if (!this.props.onChange) return;

    const oldProps = this._getPanoramaOptions(this.props);
    const newVal = {
      type: 'Point',
      properties: {
        heading: val.heading || oldProps.pov.heading,
        pitch: val.pitch || oldProps.pov.pitch,
        zoom: val.zoom || oldProps.zoom
      },
      coordinates: val.coordinates || [oldProps.position.lng, oldProps.position.lat]
    };
    if (!isEqual(this.props.value, newVal)) { this.props.onChange(newVal); }
  }

  render() {
    const { children, className } = this.props;

    return (
      <div className={className ? `mapsContainer ${className}` : 'mapsContainer'}>
        <div style={{ height: '100%' }}>
          {children}
        </div>
      </div>
    );
  }
}

function mapScriptsToProps() {
  return {
    googleMaps: {
      globalPath: 'google.maps',
      url: `https://maps.googleapis.com/maps/api/js?key=${projectConfig.apiKeys.googleMaps}`,
      jsonp: true
    }
  };
}

export default asyncLoading(mapScriptsToProps)(StreetView);
